import Vue from 'vue'
import Vuex from 'vuex'

// import { isNaN } from 'lodash'

/*
  프로모션 메뉴(카테고리) 스토어
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'homeInfo'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        isDeskTopMode: true, // Desktop Mode 플래그
        mobileInfo: {}, // 모바일웹 기본 정보
        menuPromoCat: {}, // 카테고리 메뉴
        deviceType: 'pc' // DeviceType (pc, mobile, tablet)
      },
      getters: {
        isDeskTopMode: state => {
          return state.isDeskTopMode
        },
        mobileInfo: state => {
          return state.mobileInfo
        },
        menuPromoCat: state => {
          return state.menuPromoCat
        },
        deviceType: state => {
          return state.deviceType
        }
      },
      mutations: {
        SET_DESKTOP_MODE (state, isDeskTopMode) {
          state.isDeskTopMode = isDeskTopMode
        },
        SET_MOBILE_INFO (state, mobileInfo) {
          state.mobileInfo = mobileInfo
        },
        SET_MENU_PROMO_CAT (state, menuPromoCat) {
          state.menuPromoCat = menuPromoCat
        },
        SET_DEVICE_TYPE (state, deviceType) {
          state.deviceType = deviceType
        }
      },
      actions: {
        async selectMenuPromoCat (context, payload) {
          var httpObj = window.vue.getInstance('http')
          try {
            // 프로모션 카테고리 포틀릿 데이터 조회
            var res = await httpObj.b2c.selectPortletDataForType(this, payload.data)
            if (res.data.status === 'OK') {
              context.commit('SET_MENU_PROMO_CAT', res.data.data)
              if (payload.callback) {
                payload.callback(res.data.data)
              }
            }
          } catch (e) {
            console.log(e)
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/nrw/homeInfo.js